import { Grid, withStyles } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
// local
import DateRangePicker from './DatePicker';

function CustomDateRangePicker(props) {
  const { classes, endDate, onChange, startDate, ...rest } = props;

  return (
    <React.Fragment>
      <Grid
        alignItems="center"
        className={classes.root}
        container
        justifyContent="center"
        spacing={1}
      >
        <Grid item>
          <DateRangePicker
            animateYearScrolling={false}
            className={classes.textField}
            format="M/D/YYYY"
            label="Date Range"
            leftArrowIcon={<KeyboardArrowLeft />}
            rightArrowIcon={<KeyboardArrowRight />}
            onChange={(date) => {
              onChange({
                startDate: date[0].startOf('day').toDate(),
                endDate: date[1].endOf('day').toDate(),
              });
            }}
            value={[
              moment(startDate).local().startOf('day'),
              moment(endDate).local().endOf('day'),
            ]}
            {...rest}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

CustomDateRangePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
};

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    flexBasis: 200,
  },
  arrow: {
    padding: 0,
    margin: 0,
  },
});

export default withStyles(styles)(CustomDateRangePicker);
